import { NgModule } from '@angular/core';
import { CmsConfig, provideConfig } from '@spartacus/core';
import {
  REQUESTED_DELIVERY_DATE_FEATURE,
  RequestedDeliveryDateRootModule,
} from '@spartacus/requested-delivery-date/root';

@NgModule({
  declarations: [],
  imports: [RequestedDeliveryDateRootModule],
  providers: [
    provideConfig(<CmsConfig>{
      featureModules: {
        [REQUESTED_DELIVERY_DATE_FEATURE]: {
          module: () => import('@spartacus/requested-delivery-date').then((m) => m.RequestedDeliveryDateModule),
        },
      },
    }),
  ],
})
export class RequestedDeliveryDateModuleFeatureModule {}
